import { useMutation } from '@tanstack/react-query'

import { type CoreItemPhotoPayload } from '@flecto/types'
import { uploadImageByBase64 } from '@flecto/utils'

type MutationPayload = {
  photos: CoreItemPhotoPayload[]
}

export function useMutationUploadItemImages() {
  return useMutation({
    mutationKey: ['MutationUploadItemImages'],
    mutationFn: async ({ photos }: MutationPayload) => {
      return await Promise.all(
        photos.map(async (photo) => {
          const { id } = await uploadImageByBase64(photo.photo_base64)

          photo.photo_image_id = id

          return photo
        })
      )
    },
  })
}
